import { PaidSickLeaveUsecase, UserDefinedRow } from "../../model";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for PaidSickLeaveUsecase  */
export class PaidSickLeaveUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * param row Row to update.
   */
  public updateUsecase(/*row: UserDefinedRow*/): void {
    // TODO: refactor this to align with the new way of constructing row label without setting the value.
  }

  /** Gets validation message for IrIncomeTypeUsecase  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: PaidSickLeaveUsecase = row.data || {};
    if (!data.kind) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noKind",
      };
    }
    return null;
  }
}
